<template>
    <select v-if="options.length > 0" v-name="name" v-model="selectedFilter" class="filter filter--dropdown" @change="changeFilter">
        <option v-for="option in options" :key="options.value" :value="option.value">{{option.label}}</option>
    </select>
</template>

<script>
export default {
    name: 'Filter',
    props: {
        name: {
            type: String,
            required: true
        },
        options: {
            type: Object,
            required: true
        },
        selectedFilter: {
            type: String,
            required: true
        },
    },
    data() {
        return {
            selectedFilter: this.selectedFilter  // Use prop to initialize selected value
        };
    },
    methods: {
        changeFilter(event) {
            this.$emit('filter-changed', event.target.value);
        }
    }
};
</script>
